export default {
  CONTAINER: 'EVENTPOPUP_CONTAINER',
  EVENT_ACTION_CLICK: 'EVENTPOPUP_EVENT_ACTION_CLICK',
  EVENT_ACTION_IMAGE: 'EVENTPOPUP_EVENT_ACTION_IMG',
  EVENT_ACTION_TEXT: 'EVENTPOPUP_EVENT_ACTION_TEXT',
};



